import { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import axios from "../../axios/AxiosInstance";
import { apiErrorMessage } from "../../utils/apiError";
import CreateContract from "../CreateContract/CreateContract";
import { duplicateContractDraft } from "../../utils/duplicateContract";
export default function DuplicateContractModal({ source, candidate, onClose }) {
  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [preparing, setPreparing] = useState(false);
  const [qualifications, setQualifications] = useState([]);
  const [chantiers, setChantiers] = useState([]);
  const [editing, setEditing] = useState(false);
  useEffect(() => {
    let active = true;
    axios
      .get("client/freelance")
      .then(({ data }) => {
        if (!active) return;
        const rows = Array.isArray(data) ? data : [];
        setClients(rows);
        const match = rows.find(
          (client) =>
            (source?.client &&
              String(client._id) ===
                String(source.client?._id || source.client)) ||
            (source?.IdClient != null &&
              client.pld != null &&
              String(client.pld) === String(source.IdClient)) ||
            (source && client.companyName === source.RaisonSociale),
        );
        setClientId(match?._id || null);
      })
      .catch((error) => {
        const detail = apiErrorMessage(error, "Impossible de charger les clients. Fermez et réessayez.");
        if (active && detail) setError(detail);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [source]);
  const client = clients.find((row) => row._id === clientId);
  const startCreation = async () => {
    if (!client || preparing) return;
    setPreparing(true);
    setError("");
    try {
      if (client.pld != null && String(client.pld).trim() !== "") {
        const { data } = await axios.get(`client/qualifications/${client.pld}`);
        setQualifications(
          Array.isArray(data?.TabQualifications) ? data.TabQualifications : [],
        );
        setChantiers(
          Array.isArray(data?.TabChantiers) ? data.TabChantiers : [],
        );
      }
      setEditing(true);
    } catch (error) {
      setError(
        apiErrorMessage(error, "Impossible de charger les postes et lieux du client. Réessayez."),
      );
    } finally {
      setPreparing(false);
    }
  };
  if (editing && client)
    return (
      <CreateContract
        client={{ ...client, contacts: client.contacts || [] }}
        initialContract={
          source ? duplicateContractDraft(source, candidate) : { candidate }
        }
        fixedCandidate={Boolean(source)}
        qualifications={qualifications}
        chantiers={chantiers}
        isCreateContract
        setIsCreateContract={(value) => {
          if (!value) onClose();
        }}
      />
    );
  return (
    <Modal
      open
      centered
      title={source ? "Dupliquer le contrat" : "Créer un contrat"}
      onCancel={() => {
        if (!preparing) onClose();
      }}
      footer={null}
    >
      {source ? (
        <p className="mb-4 text-sm text-slate-500">
          Contrat {source.NumeroContrat} : même client et même intérimaire. Le
          poste et le lieu sont repris ; renseignez les nouvelles dates et les
          nouveaux horaires.
        </p>
      ) : (
        <p className="mb-4 text-sm text-slate-500">
          Choisissez le client pour créer une nouvelle demande avec ce candidat.
        </p>
      )}
      {error && (
        <p role="alert" className="mb-3 text-red-700">
          {error}
        </p>
      )}
      <label className="mb-2 block text-sm font-medium">
        Client de la nouvelle demande
      </label>
      <Select
        disabled={Boolean(source)}
        aria-label="Client de la nouvelle demande"
        loading={loading}
        showSearch
        optionFilterProp="label"
        className="w-full"
        value={clientId || undefined}
        onChange={setClientId}
        placeholder="Choisir le client"
        options={clients.map((row) => ({
          value: row._id,
          label: row.companyName || row.denomination || "Client",
        }))}
      />
      {source && !loading && !client && !error && (
        <p role="alert" className="mt-2 text-sm text-amber-700">
          Le client d’origine n’est pas disponible dans la liste des clients. La
          duplication nécessite ce même client.
        </p>
      )}
      <div className="mt-5 flex justify-end gap-2">
        <button
          onClick={onClose}
          className="rounded-lg border px-4 py-2 text-sm"
        >
          Annuler
        </button>
        <button
          disabled={!client || loading || preparing}
          onClick={startCreation}
          className="rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50"
        >
          {preparing
            ? "Chargement…"
            : source
              ? "Reprendre les informations"
              : "Créer le contrat"}
        </button>
      </div>
    </Modal>
  );
}
